import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getAutoTargetReviewEndpoint } from '../../../common/endpoints';

export const fetchAutoTargetReviewData = createApi(getAutoTargetReviewEndpoint, 'GET');

const GetAutoTargetReview = createSlice({
  name: 'GetAutoTargetReview',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAutoTargetReviewData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAutoTargetReviewData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAutoTargetReviewData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAutoTargetReview.reducer;